/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { DeleteAccountResponse, DeleteAccountVars } from '../openapi-types.gen.js';

export type { DeleteAccountResponse, DeleteAccountVars } from '../openapi-types.gen.js';

export const useDeleteAccount = createMutationHook<DeleteAccountVars, DeleteAccountResponse, unknown>({
  specName: 'useDeleteAccount',
  path: '/v1/me',
  method: 'DELETE',
  resolveUrl: (vars: DeleteAccountVars) => `/v1/me`,
  buildBody: (vars: DeleteAccountVars) => ({ confirmation: vars.confirmation }),
  parseResponse: (raw: unknown): DeleteAccountResponse => raw as DeleteAccountResponse,
  
  
  
});
